import request from '@/utils/request'

// 获取店铺通知列表
export function listShopMsg(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMsg.listShopMsg',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存店铺通知
export function saveShopMsg(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMsg.saveShopMsg',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新店铺通知
export function updateShopMsg(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMsg.updateShopMsg',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除店铺通知
export function deleteShopMsg(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMsg.deleteShopMsg',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}